import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { 
  Lock, 
  Unlock,
  Shield,
  Building2
} from 'lucide-react';

const AdminPortal = () => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [accessCode, setAccessCode] = useState('');

  const ADMIN_CODE = 'HIRONDELLES-ADMIN';

  // Vérifier l'accès persistant au chargement
  useEffect(() => {
    const savedAccess = localStorage.getItem('hirondelles_admin_portal_access');
    console.log('🔍 Vérification accès admin portal sauvegardé:', savedAccess);
    
    if (savedAccess === 'granted') {
      console.log('✅ Accès admin portal déjà accordé, déverrouillage automatique');
      setIsUnlocked(true);
    } else {
      console.log('⚠️ Aucun accès admin portal sauvegardé, demande de code nécessaire');
    }
  }, []);

  const handleUnlock = () => {
    console.log('🔑 Tentative de déverrouillage Admin Portal');
    console.log('Code saisi:', accessCode);
    console.log('Code attendu:', ADMIN_CODE);
    
    if (accessCode.trim().toUpperCase() === ADMIN_CODE.toUpperCase()) {
      console.log('✅ Code correct, déverrouillage Admin Portal...');
      setIsUnlocked(true);
      
      // Sauvegarder l'accès admin portal
      localStorage.setItem('hirondelles_admin_portal_access', 'granted');
      
      console.log('✅ Admin Portal déverrouillé avec succès');
    } else {
      console.log('❌ Code incorrect');
      alert(`Code d'accès incorrect.\\n\\nCode attendu: ${ADMIN_CODE}\\nCode saisi: ${accessCode}`);
      setAccessCode(''); // Vider le champ
    }
  };

  if (!isUnlocked) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <Card className="w-full max-w-md shadow-2xl border-0 bg-white">
          <CardHeader className="text-center pb-6">
            <div className="mx-auto mb-6 p-4 bg-primary/10 rounded-full w-fit">
              <Shield className="h-12 w-12 text-primary" />
            </div>
            <CardTitle className="text-3xl font-bold text-gray-900 mb-2">
              Admin Portal 2.0
            </CardTitle>
            <p className="text-gray-600 text-lg">
              Back-office Les Hirondelles
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Accès protégé par code administrateur
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-3">
              <Label htmlFor="access-code" className="text-base font-medium">
                Code d'accès administrateur
              </Label>
              <Input
                id="access-code"
                type="password"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                placeholder="Entrez le code d'accès"
                onKeyPress={(e) => e.key === 'Enter' && handleUnlock()}
                className="h-12 text-lg"
              />
            </div>
            <Button 
              onClick={handleUnlock} 
              className="w-full h-12 text-lg font-semibold bg-primary hover:bg-primary/90"
            >
              <Unlock className="h-5 w-5 mr-3" />
              Accéder au Back-office
            </Button>
            
            <div className="pt-4 border-t border-gray-200">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Building2 className="h-4 w-4" />
                <span>SARL LAUDARE - Les Hirondelles</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Redirection vers le dashboard principal après déverrouillage
  window.location.hash = '/admin/dashboard';
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-gray-600">Chargement du back-office...</p>
      </div>
    </div>
  );
};

export default AdminPortal;